(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fw-mix-kit-split-hero-section"] && !Shopify.designMode) return;
  try {
    







(function(){







  function initFwMixVideo(section){







    var trigger=section.querySelector('[data-fw-video-open]');







    var modal=section.querySelector('[data-fw-video-modal]');







    if(!trigger||!modal)return;







    var video=modal.querySelector('video');







    var closers=modal.querySelectorAll('[data-fw-video-close]');







    var lastFocused=null;















    function openModal(){







      lastFocused=document.activeElement;







      modal.classList.add('is-open');







      modal.setAttribute('aria-hidden','false');







      document.body.classList.add('fw-mix-video-open');







      setTimeout(function(){







        if(video){







          video.currentTime=0;







          var p=video.play();







          if(p&&p.catch)p.catch(function(){});







        }







      },80);







    }















    function closeModal(){







      modal.classList.remove('is-open');







      modal.setAttribute('aria-hidden','true');







      document.body.classList.remove('fw-mix-video-open');







      if(video){video.pause();video.currentTime=0;}







      if(lastFocused&&lastFocused.focus)lastFocused.focus();







    }















    trigger.addEventListener('click',openModal);







    closers.forEach(function(el){el.addEventListener('click',closeModal);});







    document.addEventListener('keydown',function(e){







      if(e.key==='Escape'&&modal.classList.contains('is-open'))closeModal();







    });







  }















  function initAll(){







    document.querySelectorAll('.fw-mix-hero').forEach(initFwMixVideo);







  }















  if(document.readyState==='loading'){







    document.addEventListener('DOMContentLoaded',initAll);







  }else{







    initAll();







  }















  document.addEventListener('shopify:section:load',function(e){







    var section=e.target.querySelector('.fw-mix-hero') || (e.target.classList && e.target.classList.contains('fw-mix-hero') ? e.target : null);







    if(section)initFwMixVideo(section);







  });







})();








  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
